import type { FaireProductEntity } from "../../entity_types/product";

export const p_vyrsnn4aun: FaireProductEntity = {
  token: "p_vyrsnn4aun",
  type: "product",
  name: "Boston Terrier Leather Hat Patch",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5833469fd8d7e170fec18b0f577968291d9fb15e49a96f9eda1a1b4239e6a2e8.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e9b25431e953b4a3f3cc660ef7423b0a481c6ecd7fb54c2cabfbea18aa9157b4.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
